import { render, staticRenderFns } from "./custom-event.vue?vue&type=template&id=c58fa67a"
import script from "./custom-event.vue?vue&type=script&lang=js"
export * from "./custom-event.vue?vue&type=script&lang=js"
import style0 from "./custom-event.vue?vue&type=style&index=0&id=c58fa67a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports